import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import Box from 'components/Box';
import BulletList from 'components/BulletList';
import Button from 'components/Button';
import CenterContent from 'components/CenterContent';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import DashedBox from 'components/DashedBox';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import PageTitle from 'components/PageTitle';
import ShadedCard from 'components/ShadedCard';
import Stack from 'components/Stack';
import Text from 'components/Text';
import { commonThumbnailOptions, handleRejectFiles } from 'components/ThumbnailUploader/utils';
import { MainThumbnailPreviewModalWrapper } from '.';
function ArtworkGuideline(_ref) {
  var guideTitle = _ref.guideTitle,
    recommendations = _ref.recommendations;
  return /*#__PURE__*/React.createElement(ShadedCard, {
    px: "m",
    py: "s",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "h2",
    mb: "xxs"
  }, guideTitle), /*#__PURE__*/React.createElement(BulletList, null, recommendations.map(function (recommendation) {
    return recommendation;
  })));
}
export function ActionWrapper(_ref2) {
  var id = _ref2.id,
    previewUrl = _ref2.previewUrl,
    _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    guideTitle = _ref2.guideTitle,
    recommendations = _ref2.recommendations,
    children = _ref2.children,
    onClose = _ref2.onClose,
    onCancel = _ref2.onCancel,
    onConfirm = _ref2.onConfirm,
    onReplace = _ref2.onReplace;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isNewImage = !!previewUrl;
  var rejectFile = useCallback(function (rejectedFiles) {
    handleRejectFiles(rejectedFiles);
  }, []);
  var acceptFile = useCallback(function (acceptedFiles) {
    onReplace({
      file: acceptedFiles[0]
    });
  }, [onReplace]);
  var _useDropzone = useDropzone(_objectSpread(_objectSpread({}, commonThumbnailOptions), {}, {
      onDropAccepted: acceptFile,
      onDropRejected: rejectFile,
      disabled: isDisabled,
      // Disable click and keydown behavior
      noClick: true,
      noKeyboard: true
    })),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    open = _useDropzone.open;
  return /*#__PURE__*/React.createElement("div", getRootProps({
    className: 'dropzone'
  }), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(MainThumbnailPreviewModalWrapper, {
    id: id,
    onClose: onClose,
    buttonText: isNewImage ? t('actions_cancel') : undefined,
    pageSections: children
  }, /*#__PURE__*/React.createElement(PageTitle, {
    size: "large",
    mb: "l"
  }, t('actions_review_cover_image')), /*#__PURE__*/React.createElement(CollectionGrid, null, /*#__PURE__*/React.createElement(CollectionGridItem, {
    large: true
  }, /*#__PURE__*/React.createElement(ArtworkGuideline, {
    guideTitle: guideTitle,
    recommendations: recommendations
  })), !isDisabled && /*#__PURE__*/React.createElement(CollectionGridItem, {
    large: true
  }, /*#__PURE__*/React.createElement(DashedBox, {
    width: "100%",
    height: "100%"
    // Only allow clicking whole area to upload when
    // there's not currently an image being previewed
    // (in that case we're showing dedicated buttons)
    ,
    onClick: isNewImage ? undefined : open,
    cursor: isNewImage ? 'default' : 'pointer'
  }, /*#__PURE__*/React.createElement(CenterContent, {
    height: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    bold: true,
    textAlign: "center",
    p: "m"
  }, isNewImage ? /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(Box, {
    as: "img",
    alt: "",
    src: previewUrl,
    maxWidth: 200,
    maxHeight: 70,
    style: {
      objectFit: 'scale-down'
    },
    boxShadow: "soft"
  }), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: onConfirm,
    isDisabled: isDisabled
  }, t('actions_confirm')), /*#__PURE__*/React.createElement(Button, {
    onClick: open,
    isDisabled: isDisabled
  }, t('actions_upload_new_image')), /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel,
    isDisabled: isDisabled
  }, t('actions_cancel')))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    dimmed: true,
    name: "drag-and-drop",
    scale: 2.5,
    mb: "xs"
  }), /*#__PURE__*/React.createElement("br", null), t('actions_click_or_drag_to_replace_image')))))))));
}
export default ActionWrapper;